var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAwv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#F3E7FC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1A6F6",
    d: "M48.125 27.25h-2.444A3.379 3.379 0 0 0 42.5 25c-1.467 0-2.718.94-3.184 2.25h-2.441c-.621 0-1.125.504-1.125 1.125v4.5c0 .621.504 1.125 1.125 1.125h11.25c.621 0 1.125-.504 1.125-1.125v-4.5c0-.621-.504-1.125-1.125-1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B268F1",
    fillRule: "nonzero",
    d: "M53.75 29.5H51.5v3.375a3.38 3.38 0 0 1-3.375 3.375h-11.25a3.38 3.38 0 0 1-3.375-3.375V29.5h-2.25c-1.24 0-2.25 1.01-2.25 2.25v27c0 1.262.988 2.25 2.25 2.25h22.5c1.262 0 2.25-.988 2.25-2.25v-27c0-1.262-.988-2.25-2.25-2.25zM42.171 49.422l-4.5 4.5a1.13 1.13 0 0 1-1.593 0l-2.25-2.25a1.126 1.126 0 0 1 1.591-1.591l1.456 1.453 3.704-3.703a1.126 1.126 0 0 1 1.592 1.59zm0-9l-4.5 4.5a1.13 1.13 0 0 1-1.593 0l-2.25-2.25a1.126 1.126 0 0 1 1.591-1.591l1.456 1.453 3.704-3.703a1.126 1.126 0 0 1 1.592 1.59zM50.376 52h-4.5a1.125 1.125 0 0 1 0-2.25h4.5a1.125 1.125 0 0 1 0 2.25zm0-9h-4.5a1.125 1.125 0 0 1 0-2.25h4.5a1.125 1.125 0 0 1 0 2.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAwv);
export default __webpack_public_path__ + "static/media/ic-awv.5cfdf2ebf77cd6a1972b90eaacb722cd.svg";
export { ForwardRef as ReactComponent };